<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :span='12'>
            <a-form-item
              :label="$t(I18N_KEY.REPAYREPORT + 'requestDate')"
              :labelCol='{ span: 6 }'
              :wrapperCol='{ span: 14, offset: 1 }'
            >
              <a-range-picker v-model='queryParam.examineDate' format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
<!--          <a-col :md='6' :sm='8'>-->
<!--            <a-form-item :label="'产品类型'">-->
<!--              <a-select v-model='queryParam.appssid'>-->
<!--                <a-select-option v-for='item in appList' :key='item.appssid'>-->
<!--                  {{ item.appName }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :span='6'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click="searchQuery('')" icon='search' style='margin-left: 8px'>{{
                  $t('search')
                }}</a-button>
<!--              <a-button type='primary' @click="searchQuery('1')" icon='search' style='margin-left: 8px'>首贷</a-button>-->
<!--              <a-button type='primary' @click="searchQuery('2')" icon='search' style='margin-left: 8px'>复贷</a-button>-->
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{
                  $t('reset')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        :scroll='{x:1000}'
        @change='handleTableChange'
      >
        <!--              :scroll="{ x: open ? 2780 : 1780, y: 600 }"-->
        <!--        <template slot="allFee">-->
        <!--          <span>总成本</span>-->
        <!--          <span style="margin-left: 20px;">-->
        <!--            <a-icon :type="open ? 'right' : 'left'" @click="openList" />-->
        <!--          </span>-->
        <!--        </template>-->

        <!--        <template slot="overDueRate">-->
        <!--          <span>实时逾期率（含滞纳金）</span>-->
        <!--          <span style="margin-left: 20px;">-->
        <!--            <a-icon :type="hideLastTwo ? 'right' : 'left'" @click="hide" />-->
        <!--          </span>-->
        <!--        </template>-->

        <!-- <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS">{{ text }}</Dict> -->
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, netProfitList } from '@/webpublicapi/order'
import exportFile from '@/webpublicapi/exportFile'

import moment from 'moment'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  REPAYREPORT: 'repayReport.'
}
export default {
  name: 'repayReport',

  data() {
    return {
      hideLastTwo: false,
      open: false,
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      exportParams: '',
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        examinerName: '',
        appssid: '',
        duration: '',
        examineDate: [ moment().add(-7, 'days').format('YYYY-MM-DD'),
          moment().add(-1, 'days').format('YYYY-MM-DD')
        ]
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      collection: [
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'curDate'),
          align: 'right',
          dataIndex: 'curDate',
          fixed: 'left',
          width: 120
        },
        {
          title: '到期应还款',
          align: 'right',
          dataIndex: 'curAmount',
          width: 120
        },
        {
          title: '实际还款金额',
          align: 'right',
          dataIndex: 'profitAmount',
        },
        {
          title: '实际放款金额',
          align: 'right',
          dataIndex: 'paymentAmt',
          width: 100
        },

        {
          title: '总成本',
          align: 'right',
          // slots: { title: 'allFee' },
          dataIndex: 'allFee',
          width: 100
        },
        {
          title: '毛利润',
          align: 'right',
          dataIndex: 'grossProfitAmt',
          width: 100
        },
        {
          title: '毛利润率',
          align: 'right',
          dataIndex: 'grossProfitRate',
          width: 100
        },
        {
          title: '净利润',
          align: 'right',
          dataIndex: 'profitAmt',
          width: 100
        },
        {
          title: '净利润率',
          align: 'right',
          dataIndex: 'profitRate',
          width: 100
        },
        {
          title: '首逾',
          align: 'right',
          dataIndex: 'firstOverDueRate',
          width: 100
        },
        {
          title: '实时逾期率（含滞纳金）',
          align: 'right',
          dataIndex: 'overDueRate',
          // slots: { title: 'overDueRate' },
          // width: 220
        },
        {
          title: '实时逾期率（不含滞纳金）',
          align: 'right',
          dataIndex: 'overDueNoLateFeeRate'
        },
        {
          title: '实时逾期率（含部分还款）',
          align: 'right',
          dataIndex: 'overDuePartRate'
        }
      ],
      // collection2: [
      //   {
      //     title: this.$t(I18N_KEY.REPAYREPORT + 'curDate'),
      //     align: 'right',
      //     dataIndex: 'curDate',
      //     fixed: 'left',
      //     width: 120
      //   },
      //   {
      //     title: '到期应还款',
      //     align: 'right',
      //     dataIndex: 'curAmount',
      //     width: 140
      //   },
      //   {
      //     title: '实际还款金额（含部分还款）',
      //     align: 'right',
      //     dataIndex: 'profitAmount',
      //     width: 200
      //   },
      //   {
      //     title: '放款金额',
      //     align: 'right',
      //     dataIndex: 'paymentAmt'
      //   },
      //
      //   {
      //     title: '总成本',
      //     align: 'right',
      //     // slots: { title: 'allFee' },
      //     dataIndex: 'allFee'
      //   },
      //   {
      //     title: '获客成本(广告成本)',
      //     align: 'right',
      //     dataIndex: 'flowFee',
      //     width: 160
      //   },
      //   {
      //     title: '新户风控成本',
      //     align: 'right',
      //     dataIndex: 'newOfficeThridFee',
      //     width: 120
      //   },
      //   {
      //     title: '老户风控成本',
      //     align: 'right',
      //     dataIndex: 'oldOfficeThridFee',
      //     width: 120
      //   },
      //   {
      //     title: '支付通道成本',
      //     align: 'right',
      //     dataIndex: 'operatingThridFee'
      //   },
      //   {
      //     title: '牌照成本',
      //     align: 'right',
      //     dataIndex: 'licenceFee'
      //   },
      //   {
      //     title: 'OCR&活体成本',
      //     align: 'right',
      //     dataIndex: 'ocrLiveFee',
      //     width: 130
      //   },
      //   {
      //     title: '短信&话条成本',
      //     align: 'right',
      //     dataIndex: 'optFee',
      //     width: 130
      //   },
      //   {
      //     title: '催收绩效与奖金成本',
      //     align: 'right',
      //     dataIndex: 'performanceBonus',
      //     width: 150
      //   },
      //   {
      //     title: '泰国本地费用成本',
      //     align: 'right',
      //     dataIndex: 'thaFee',
      //     width: 140
      //   },
      //   {
      //     title: '总部成本',
      //     align: 'right',
      //     dataIndex: 'centerFee'
      //   },
      //   {
      //     title: '老挝成本',
      //     align: 'right',
      //     dataIndex: 'laosFee'
      //   },
      //   {
      //     title: '海外房租成本',
      //     align: 'right',
      //     dataIndex: 'rentFee'
      //   },
      //   {
      //     title: '利润',
      //     align: 'right',
      //     dataIndex: 'profitAmt'
      //   },
      //   {
      //     title: '首逾',
      //     align: 'right',
      //     dataIndex: 'firstOverDueRate'
      //   },
      //   {
      //     title: '利润率',
      //     align: 'right',
      //     dataIndex: 'profitRate'
      //   },
      //   {
      //     align: 'right',
      //     dataIndex: 'overDueRate',
      //     slots: { title: 'overDueRate' },
      //     width: 220
      //   },
      //   {
      //     title: '实时逾期率（不含滞纳金）',
      //     align: 'right',
      //     dataIndex: 'overDueNoLateFeeRate'
      //   },
      //   {
      //     title: '实时逾期率（含部分还款）',
      //     align: 'right',
      //     dataIndex: 'overDuePartRate'
      //   }
      // ],
      columns: []
    }
  },
  // computed: {
  //   columns() {
  //     return this.collection
  //   }
  // },
  created() {
    this.columns = this.collection
    this.loadData(1)
    getApplist().then(res => {
      this.appList = []
      this.appInList = res.data || []
      for (var i = 0; i < this.appInList.length; i++) {
        if (this.appInList[i].appssid != '') {
          this.appList.push(this.appInList[i])
        }
      }
    })
  },
  methods: {
    // hide() {
    //   this.hideLastTwo = !this.hideLastTwo
    //   if (this.hideLastTwo) {
    //     this.columns.splice(this.columns.length - 1)
    //     this.columns.splice(this.columns.length - 1)
    //   } else {
    //     this.columns.push({
    //       title: '实时逾期率（不含滞纳金）',
    //       align: 'right',
    //       dataIndex: 'overDueNoLateFeeRate'
    //     })
    //     this.columns.push({
    //       title: '实时逾期率（含部分还款）',
    //       align: 'right',
    //       dataIndex: 'overDuePartRate'
    //     })
    //   }
    // },
    // openList() {
    //   this.open = !this.open
    //   if (this.open) {
    //     this.columns = this.collection2
    //   } else {
    //     this.columns = this.collection
    //   }
    //
    //   if (this.hideLastTwo) {
    //     this.columns.splice(this.columns.length - 1)
    //     this.columns.splice(this.columns.length - 1)
    //   } else {
    //     this.columns.push({
    //       title: '实时逾期率（不含滞纳金）',
    //       align: 'right',
    //       dataIndex: 'overDueNoLateFeeRate'
    //     })
    //     this.columns.push({
    //       title: '实时逾期率（含部分还款）',
    //       align: 'right',
    //       dataIndex: 'overDuePartRate'
    //     })
    //   }
    // },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery(arg) {
      this.loadData(1, arg)
    },
    loadData(arg, arg2) {
      // 加载数据 若传入参数1则加载第一页的内容
      console.log(arg2)
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams(arg2) // 查询条件
      this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value)
      netProfitList(Object.assign({}, params))
        .then(res => {
          if (res.code === 1000) {
            // this.total = res.data && res.data.total
            this.dataSource = res.data || []
            //干掉利润计算
            // for(var i = 0 ; i < this.dataSource.length ; i ++){
            //   var dataIn = this.dataSource[i];
            //   dataIn.profit = (dataIn.profitAmount - dataIn.paymentAmt).toFixed(2);
            // }
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    downLoadData() {
      const file = {
        fileUrl: '/api/web/statistics/platform/repaymentReportExcel?' + this.exportParams,
        fileName: 'report.xls'
      }
      this.loading = true
      exportFile(file)
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams(arg) {
      const { examineDate } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: examineDate && this.transformTime(examineDate[0]),
        endDate: examineDate && this.transformTime(examineDate[1]),
        loanType: arg
      }
      delete data.examineDate
      return filterObj(data)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.examinerName = ''
      that.queryParam.examineDate = undefined
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import '~@/assets/less/common.less';
</style>
